import script from "./PendingView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PendingView.vue?vue&type=script&lang=ts&setup=true"

import "./PendingView.vue?vue&type=style&index=0&id=7921d50a&lang=scss"

const __exports__ = script;

export default __exports__